import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDdStepCompleted = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsxs("g", {
		transform: "translate(0 0.3636) scale(0.7273)",
		children: [/* @__PURE__ */ _jsx("rect", {
			x: .601562,
			width: 32,
			height: 32,
			rx: 16,
			fill: "white"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M12.6016 16.0002L15.2682 18.6668L20.6016 13.3335",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})]
	})]
});
const ForwardRef = forwardRef(SvgDdStepCompleted);
export default ForwardRef;
